var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about w3-container"},[_c('h2',[_vm._v("number of patients is: "+_vm._s(_vm.patientCount))]),_c('h2',[_vm._v("you have access to institutions: "+_vm._s(_vm.prisonCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }